// Generated file. Do not modify.
module.exports = require('./src/interface');
